import { Component, Input, OnInit } from '@angular/core';
import WorkflowHelper from '../../../../../../shared/WorkflowHelper';
import { WorkflowKeyValuePairService } from '../../../../../../services/workflow-keyvaluepair.service';
import { finalize, forkJoin } from 'rxjs';
import { CustomerCampaignService } from '../../../../../../services/customer-campaign.service';

@Component({
  selector: 'app-components-specialist-actioncomponents-page-optimization-shared-instructions',
  templateUrl: './instructions.component.html'
})
export class PageOptimizationInstructionsComponent implements OnInit {
  @Input() taskId: number;
  @Input() websiteUrlId: number;
  @Input() googleSearchUrl: string;
  @Input() showNotesForContentWriter = true;

  isLoading = true;
  pageType: string;
  notesForContentWriter: string;
  notesForImplementationSpecialist: string;
  url: string;
  keywordPhrases: string[];

  constructor(
    private customerCampaignService: CustomerCampaignService,
    private workflowKeyValuePairService: WorkflowKeyValuePairService) { }

  ngOnInit(): void {
    forkJoin([
      this.workflowKeyValuePairService.getByTaskId(this.taskId),
      this.customerCampaignService.getWebsiteUrl(this.websiteUrlId)
    ])
    .pipe(
      finalize(() => this.isLoading = false)
    )
    .subscribe({
      next: ([keyValuePairs, websiteUrl]) => {
        this.pageType = WorkflowHelper.get<string>(keyValuePairs, Boo.Objects.Enums.KeyEnum.PageType);
        this.notesForContentWriter = WorkflowHelper.get<string>(keyValuePairs, Boo.Objects.Enums.KeyEnum.NotesForContentWriter);
        this.notesForImplementationSpecialist = WorkflowHelper.get<string>(keyValuePairs, Boo.Objects.Enums.KeyEnum.NotesForImplementationSpecialist);
        this.url = websiteUrl.Url;
        this.keywordPhrases = websiteUrl.Keywords.filter(x => x.IsActive).map(x => x.KeywordPhrase);
      },
      error: (err) => toastr.error('Failed to load instructions:', err)
    });
  }
}
